'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTranslate = function MdTranslate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.5 28.4h5.4l-2.8-7.3z m4.4-11.8l7.5 20h-3.4l-1.9-5h-7.9l-1.8 5h-3.4l7.5-20h3.4z m-9.4 8.5l-1.3 3.4-5.2-5.1-8.4 8.2-2.3-2.3 8.5-8.4c-2.1-2.3-3.7-4.8-5-7.5h3.4c1 1.9 2.2 3.8 3.8 5.5 2.4-2.6 4.2-5.7 5.3-8.9h-18.7v-3.4h11.8v-3.2h3.2v3.2h11.8v3.4h-5c-1.2 3.9-3.2 7.7-6.1 10.9l-0.1 0z' })
        )
    );
};

exports.default = MdTranslate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/translate.js
// module id = 2072
// module chunks = 168707334958949